const isServer = () => typeof process !== "undefined";

const isClient = () => !isServer();

export { isServer, isClient };
